import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { filter, Subscription} from 'rxjs';
import { map, concatMap, finalize } from 'rxjs/operators';
import { FilterService } from 'primeng/api';
import { Table } from 'primeng/table';

import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'

import { CliListEntry } from 'src/app/shared/cli-list-entry';
import { ClientApiService } from 'src/app/services/client-api.service';

@Component({
  selector: 'app-list-client-lcos',
  templateUrl: './list-client-lcos.component.html',
  styleUrls: ['./list-client-lcos.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ListClientLcosComponent implements OnInit, OnDestroy, OnChanges {

  globalSettinsData: GlobalSettingsData;

  @Input() clientId: number;

  @ViewChild('ptable1') ptable1: Table;

  cf1: any = {};    // to store f[string] filters value

  loading: boolean = false;

  private listLcoQuery: Subscription;

  totalRecords: number = 0;
  lcoList: CliListEntry[] = [];
  selectedRecord: CliListEntry = null;

  constructor(
    private cliApi: ClientApiService,
    private filterService: FilterService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnDestroy(): void {
    console.log('*** ListClientLcosComponent in ngOnDestroy')

    if (this.listLcoQuery) { this.listLcoQuery.unsubscribe(); }

  }

  loadClientInformation() {
    if (this.globalSettinsData) {
      this.loading = true;

      this.listLcoQuery =
        this.cliApi.getClientById(this.clientId).pipe(
          filter(clientData => clientData && (clientData.length > 0)),
          map(clientData => clientData[0]),
          filter(clientData => clientData && (clientData.CASTCATID != 0)),
          concatMap(clientData => this.cliApi.getCliChildList(clientData.CLIID)),
          map(data => {
            this.lcoList = data || [];
            this.totalRecords = this.lcoList.length;
          }),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe();
    }
}

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** ListClientLcosComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      switch (propName) {
        case 'clientId':
          this.loadClientInformation();
          break;
      }
    }
  }

  ngOnInit(): void {
    console.log('*** ListClientLcosComponent ngOnInit:');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );
    this.loadClientInformation();
  }
}
